import { render, staticRenderFns } from "./email_compose_panel.vue?vue&type=template&id=d71820d0&"
import script from "./email_compose_panel.vue?vue&type=script&lang=js&"
export * from "./email_compose_panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d71820d0')) {
      api.createRecord('d71820d0', component.options)
    } else {
      api.reload('d71820d0', component.options)
    }
    module.hot.accept("./email_compose_panel.vue?vue&type=template&id=d71820d0&", function () {
      api.rerender('d71820d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/mailboxer/email_compose_panel.vue"
export default component.exports